<template>
        <transition name="fade">
            <div class="modMessageBackground">
                <div class="modalMessageContainer">
                    <div class="modalMessageHeading bg-info text-left text-light">
                        Action Status
                    </div> 
                    <div class="card-text modalMessageContent rounded text-center">
                        <div v-if="successMessage" class="text-success my-4 text-center">
                            <div v-html="successMessage"></div>                           
                        </div>
                        <div v-if="errorMessage" class="text-danger my-4 text-center">
                            <div v-html="errorMessage"></div>
                                <hr>                            
                                <button class="btn btn-outline-success" @click="closeDialogue">Понятно...</button> 
                        </div>                                                    
                    </div>
                </div>
            </div>
        </transition>
</template>

<script>
    export default {
            props: ['successMessage', 'errorMessage'],
            methods: {
                closeDialogue(){
                    this.$emit('showDialogue', false)
                }
            }
        }
</script>




// WEBPACK FOOTER //
// src/components/Helpers/ConfirmationDialogue.vue